import React, { useState, Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Input,
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  CardTitle,
  CardText,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./wiki.css";
import { saveWiki, getWiki, deleteWiki, updateWiki,saveAnnouncements } from "../../actions";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin, appInsights } from "../../AppInsights";
import jwt_decode from "jwt-decode";
import deleteIcon from "../../assets/delete.svg";
import draftIcon from "../../assets/draft.svg";
import publishIcon from "../../assets/publish.svg";
import moment from "moment";
import editIcon from "../../assets/edit.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const decoded = localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")) : null;
const role = decoded ? (decoded.roles ? decoded.roles[0] : decoded.lab || '') : '';

let arr = [];
const rolesEnv = process.env.REACT_APP_ROLES || 'Admin,User,Manager';
rolesEnv.split(",").forEach((role) => {
  arr.push({ value: role, label: role });
});
let user;

class Wiki extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      draftState: "",
      draftArticleId: "",
      roles: arr,
      selected: [],
      isPublic: false,
      isArticalNew: false,
      isArticalEdit: false,
      isPublished: false,
      isDraft: false,
      isButtonDisabled: true,
      articleSearchFilter: props.searchFilterword?props.searchFilterword:"",
      deleteWikiId: "",
      isDeleteWikiModalOpen: false,
    };
    if (localStorage.getItem("auth_token")) {
      user = jwt_decode(localStorage.getItem("auth_token"));
    }
  }
  componentDidMount() {
    this.props.getWiki();
  }
  editData = (rawData) => {
    if (this.state.isArticalEdit || this.state.isArticalNew) {
      let message = "Publish ,Save or close the currently edited article";
      toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    this.setState({
      isArticalEdit: true,
      draftArticleId: rawData.id,
      isButtonDisabled: true,
      draftState: EditorState.createWithContent(
        convertFromRaw(rawData.content)
      ),
    });
  };
  publishEditData = () => {
    let data = {
      content: convertToRaw(this.state.editorState.getCurrentContent()),
      id: this.state.draftArticleId,
      draft: false,
    };
    if (role == "Lab.Tech") {
      // Can be used when roles can be selected for Lab.Tech
      // data["access_roles"] = this.state.isPublic
      //   ? "Public"
      //   : this.state.selected.join(",");
      data["access_roles"] = "Public";
    }
    this.setState({
      draftArticleId: "",
      editorState: EditorState.createEmpty(),
      isArticalEdit: false,
    });
    this.props.updateWiki(data).then((response) => {
      if (response.status === 200) {
        let message = "Your article has been published successfully";
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        let message = "Problem while updating article";
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    });
  };
  handleClick = () => {
    this.setState({ isPublic: !this.state.isPublic, isButtonDisabled: true });
  };
  handleArticleAdd = () => {
    if (this.state.isArticalEdit) {
      let message = "Publish ,Save or close the currently edited article";
      toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    this.setState({
      editorState: EditorState.createEmpty(),
      isButtonDisabled: true,
      isArticalNew: !this.state.isArticalNew,
    });
  };
  handleNewArticleClose = () => {
    this.setState({ isArticalNew: false, isButtonDisabled: true });
  };
  handleArticleEdit = () => {
    this.setState({
      isArticalEdit: false,
      draftArticleId: "",
      isButtonDisabled: true,
    });
  };
  handlePublish = () => {
    this.setState({
      isArticalNew: false,
      isDraft: true,
      isPublished: true,
      isButtonDisabled: true,
    });
  };
  handleDraft = () => {
    this.setState({
      isArticalNew: false,
      isPublished: false,
      isDraft: true,
      isButtonDisabled: true,
    });
  };
  onChange = (editorState) => {
    this.setState({ editorState: editorState, isButtonDisabled: false });
  };
  handleBackToWikiClick = () => {
    this.setState({ isArticalNew: false, isPublished: false, isDraft: false });
  };
  toggleWikiDeleteModal = () => {
    this.setState((prevState) => ({
      isDeleteWikiModalOpen: !prevState.isDeleteWikiModalOpen,
      deleteWikiId: "",
    }));
  };
  toggleWikiDeleteClick = (wikiId) => {
    this.setState((prevState) => ({
      isDeleteWikiModalOpen: !prevState.isDeleteWikiModalOpen,
      deleteWikiId: wikiId,
    }));
  };
  deleteWiki = () => {
    this.props.deleteWiki(this.state.deleteWikiId).then((response) => {
      if (response.status === 204) {
        let message = "The article has been deleted successfully";
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        let message = "Problem while deleting article";
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    });
    this.setState((prevState) => ({
      isDeleteWikiModalOpen: !prevState.isDeleteWikiModalOpen,
      deleteWikiId: "",
    }));
  };
  saveDraftData = () => {
    let data = {
      content: convertToRaw(this.state.editorState.getCurrentContent()),
      draft: true,
    };
    user.name?data["creator"]=user.name:data["creator"]="Not Available"
    if (role == "Lab.Tech")
      // Can be used when roles can be selected for Lab.Tech
      // data["access_roles"] = this.state.isPublic
      //   ? "Public"
      //   : this.state.selected.join(",");
      data["access_roles"] = "Public";
    this.setState({
      editorState: EditorState.createEmpty(),
      isArticalNew: false,
    });
    this.props.saveWiki(data).then((response) => {
      if (response.status === 201) {
        let message = "Your articles is saved under 'Drafts'";
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        let message = "Problem while moving to draft article";
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    });
  };
  saveEditDraftData = () => {
    let data = {
      content: convertToRaw(this.state.editorState.getCurrentContent()),
      id: this.state.draftArticleId,
      draft: true,
    };
    if (role == "Lab.Tech") {
      // Can be used when roles can be selected for Lab.Tech
      // data["access_roles"] = this.state.isPublic
      //   ? "Public"
      //   : this.state.selected.join(",");
      data["access_roles"] = "Public";
    }
    this.setState({
      draftArticleId: "",
      editorState: EditorState.createEmpty(),
      isArticalEdit: false,
    });
    this.props.updateWiki(data).then((response) => {
      if (response.status === 200) {
        let message = "Your articles is saved under 'Drafts'";
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        let message = "Problem while moving to draft article";
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    });
  };
  saveData = () => {
    let data = {
      content: convertToRaw(this.state.editorState.getCurrentContent()),
    };
    user.name?data["creator"]=user.name:data["creator"]="Not Available"
    if (role == "Lab.Tech")
      // Can be used when roles can be selected for Lab.Tech
      // data["access_roles"] = this.state.isPublic
      //   ? "Public"
      //   : this.state.selected.join(",");
      data["access_roles"] = "Public";
      
    this.setState({
      editorState: EditorState.createEmpty(),
      isArticalNew: false,
    });
    this.props.saveWiki(data).then((response) => {
      if (response.status === 201) {
        if (role == "Lab.Tech"){
          let headline=""
          if((response.data.content.blocks[0].text).length>10){
            headline=response.data.content.blocks[0].text.slice(0,12)+"..."
          }else{
            headline=response.data.content.blocks[0].text 
          }
          this.props.saveAnnouncements({title:headline  ,description:data["creator"],wiki_refid:response.data.id})}
        let message = "Your article has been published successfully";
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        let message = "Problem while adding article";
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }

    });
  };
  searchFilter = (search) => {
    this.setState({ articleSearchFilter: search.target.value });
  };
  searchArticle = (rawContent) => {
    if ((
      rawContent.content.blocks.filter((i) =>
        i.text
          .toLowerCase()
          .includes(this.state.articleSearchFilter.toLowerCase())
      ).length > 0
    ) ||  (String(rawContent.id)===this.props.searchFilterword) && rawContent.access_roles ) {
      return true;
    } else {
      return false;
    }
  };
  render() {
    return (
      <div>
        <div className="wiki-page-layout">
          <span className="wiki-header" onClick={this.handleBackToWikiClick}>
            Wiki Space
          </span>
          <span className="wiki-search">
            <Input
              className="search-wiki-input"
              name="searchWiki"
              id="searchWiki"
              placeholder="Search Articles"
              autoComplete="off"
              onChange={(search) => this.searchFilter(search)}
            />
          </span>
          <span>
            <abbr title="My Published">
              <img
                className="wiki-icons wiki-publish-icon"
                src={publishIcon}
                alt=""
                onClick={this.handlePublish}
              />
            </abbr>
          </span>
          <span>
            <abbr title="Draft">
              <img
                className="wiki-icons wiki-draft-icon"
                src={draftIcon}
                alt=""
                onClick={this.handleDraft}
              />
            </abbr>
          </span>
          <span>
            <Button
              className="wiki-article-button"
              type="submit"
              outline
              color="secondary"
              onClick={this.handleArticleAdd}
            >
              <span className="wiki-plus-button">
                <FontAwesomeIcon icon={faPlus} size="sm" />
                <span className="wiki-button-text">New Article</span>
              </span>
            </Button>
          </span>
        </div>
        <div>
          <hr></hr>
          <Modal
            isOpen={this.state.isDeleteWikiModalOpen}
            toggle={this.isDeleteWikiModalOpen}
          >
            <ModalHeader
              toggle={this.toggleWikiDeleteModal}
              className="edit-popup delete-title"
            >
              <FontAwesomeIcon
                className="warning-icon"
                icon={faExclamationTriangle}
              />
              Delete Wiki
            </ModalHeader>
            <ModalBody className="delete-popup-body">
              Are you sure you want to delete the selected Article?
            </ModalBody>
            <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
              <Button
                className="custom-button cancel-button mr-2 custom-dimension"
                outline
                color="secondary"
                onClick={this.toggleWikiDeleteModal}
              >
                No
              </Button>
              <Button
                id="deleteButton"
                className="custom-button save-upload-delete-button"
                onClick={this.deleteWiki}
              >
                Yes
              </Button>
            </ModalFooter>
          </Modal>
          {this.state.isArticalNew ? (
            <div className="new-artical-box">
              <Editor
                editorState={this.state.editorState}
                onEditorStateChange={this.onChange}
                editorClassName="wiki-editor"
              />
              <div>
                <Button
                  className="wiki-article-cancle-button"
                  type="submit"
                  outline
                  color="secondary"
                  onClick={() => this.handleNewArticleClose()}
                >
                  Cancel
                </Button>
                <Button
                  className="apply-button button-size wiki-article-save-button"
                  type="submit"
                  outline
                  color="secondary"
                  onClick={() => this.saveDraftData()}
                  disabled={this.state.isButtonDisabled}
                >
                  Save
                </Button>
                <Button
                  className="wiki-article-publish-button"
                  type="submit"
                  outline
                  color="secondary"
                  onClick={() => this.saveData()}
                  disabled={this.state.isButtonDisabled}
                >
                  Publish
                </Button>
              </div>
            </div>
          ) : null}
          {this.state.isArticalEdit ? (
            <div className="new-artical-box">
              <Editor
                defaultEditorState={this.state.draftState}
                onEditorStateChange={this.onChange}
                editorClassName="wiki-editor"
              />
              <div>
                <Button
                  className="wiki-article-cancle-button"
                  type="submit"
                  outline
                  color="secondary"
                  onClick={() => this.handleArticleEdit()}
                >
                  Cancel
                </Button>
                <Button
                  className="apply-button button-size wiki-article-save-button"
                  type="submit"
                  outline
                  color="secondary"
                  onClick={() => this.saveEditDraftData()}
                  disabled={this.state.isButtonDisabled}
                >
                  Save
                </Button>
                <Button
                  className="wiki-article-publish-button"
                  type="submit"
                  outline
                  color="secondary"
                  onClick={() => this.publishEditData()}
                  disabled={this.state.isButtonDisabled}
                >
                  Publish
                </Button>
              </div>
            </div>
          ) : null}
        </div>
        <div>
          {this.state.isPublished ? (
            <div>
              <div>
                <span>
                  <span>
                    <img
                      className="wiki-icons wiki-publish-icon"
                      src={publishIcon}
                      alt=""
                    />
                  </span>
                </span>
                <span className="my-published">My Published</span>
              </div>
              {role == "Lab.Tech"
                ? this.props.wikiList.map((rawData) => (
                    <>
                      {!rawData.draft ? (
                        <Card
                          className={
                            this.searchArticle(rawData)
                              ? "article-card"
                              : "article-card-search"
                          }
                        >
                          <div>
                            <div
                              className="delete-div"
                              onClick={() =>
                                this.toggleWikiDeleteClick(rawData.id)
                              }
                            >
                              <img
                                src={deleteIcon}
                                className="delete-icon"
                                alt=""
                              />
                              <span> Delete</span>
                            </div>
                            <div
                              className="edit-div"
                              onClick={() => this.editData(rawData)}
                            >
                              <img
                                src={editIcon}
                                alt=""
                                className="edit-icon"
                              />
                              <span> Edit</span>
                            </div>
                            <CardHeader className="article-header my-published-body">
                              {/* { <span className="article-card-publish">
                                Published by :{" "}
                                <span className="article-card-publish-font">
                                  {rawData.creator}
                                </span>
                              </span> } */}
                              <span className="article-card-date">
                                Modified on :
                                <span className="article-card-date-font">
                                  {" "}
                                  {moment(new Date(rawData.updated_at)).format(
                                    "MMMM D, YYYY"
                                  )}
                                </span>
                              </span>
                            </CardHeader>
                            <CardBody
                              className="my-published-body"
                              style={{
                                maxHeight:
                                  this.state.articleSearchFilter != ""
                                    ? "max-content"
                                    : "10rem",
                              }}
                            >
                              <CardText>
                                <span className="article-text">
                                  <Editor
                                    editorState={EditorState.createWithContent(
                                      convertFromRaw(rawData.content)
                                    )}
                                    readOnly
                                    toolbarHidden
                                  />
                                </span>
                              </CardText>
                            </CardBody>
                            <br></br>
                          </div>
                        </Card>
                      ) : null}
                    </>
                  ))
                : this.props.wikiList.map((wiki, index) =>
                    Array.isArray(wiki)
                      ? wiki.map((rawData) => (
                          <Card
                            className={
                              this.searchArticle(rawData)
                                ? "article-card"
                                : "article-card-search"
                            }
                          >
                            {index == 0 && !rawData.draft ? (
                              <div>
                                <div
                                  className="delete-div"
                                  onClick={() =>
                                    this.toggleWikiDeleteClick(rawData.id)
                                  }
                                >
                                  <img
                                    src={deleteIcon}
                                    className="delete-icon"
                                    alt=""
                                  />
                                  <span> Delete</span>
                                </div>
                                <div
                                  className="edit-div"
                                  onClick={() => this.editData(rawData)}
                                >
                                  <img
                                    src={editIcon}
                                    alt=""
                                    className="edit-icon"
                                  />
                                  <span> Edit</span>
                                </div>
                                <CardHeader className="article-header my-published-body">
                                  {/* { <span className="article-card-publish">
                                    Published by :{" "}
                                    <span className="article-card-publish-font">
                                      {rawData.creator}
                                    </span>
                                  </span> } */}
                                  <span className="article-card-date">
                                    Modified on :
                                    <span className="article-card-date-font">
                                      {" "}
                                      {moment(
                                        new Date(rawData.updated_at)
                                      ).format("MMMM D, YYYY")}
                                    </span>
                                  </span>
                                </CardHeader>
                                <CardBody
                                  className="my-published-body"
                                  style={{
                                    maxHeight:
                                      this.state.articleSearchFilter != ""
                                        ? "max-content"
                                        : "10rem",
                                  }}
                                >
                                  <CardText>
                                    <span className="article-text">
                                      <Editor
                                        editorState={EditorState.createWithContent(
                                          convertFromRaw(rawData.content)
                                        )}
                                        readOnly
                                        toolbarHidden
                                      />
                                    </span>
                                  </CardText>
                                </CardBody>
                                <br></br>
                              </div>
                            ) : null}
                          </Card>
                        ))
                      : null
                  )}
            </div>
          ) : this.state.isDraft ? (
            <div>
              <div>
                <span>
                  <span>
                    <img
                      className="wiki-icons wiki-draft-icon"
                      src={draftIcon}
                      alt=""
                      onClick={this.handleDraft}
                    />
                  </span>
                </span>
                <span className="my-published">Draft</span>
              </div>
              {role == "Lab.Tech"
                ? this.props.wikiList.map((rawData) => (
                    <div>
                      {rawData.draft ? (
                        <Card
                          className={
                            this.searchArticle(rawData)
                              ? "article-card"
                              : "article-card-search"
                          }
                        >
                          <div>
                            <div
                              className="delete-div"
                              onClick={() =>
                                this.toggleWikiDeleteClick(rawData.id)
                              }
                            >
                              <img
                                src={deleteIcon}
                                className="delete-icon"
                                alt=""
                              />
                              <span> Delete</span>
                            </div>
                            <div
                              className="edit-div"
                              onClick={() => this.editData(rawData)}
                            >
                              <img
                                src={editIcon}
                                alt=""
                                className="edit-icon"
                              />
                              <span> Edit</span>
                            </div>

                            <CardHeader className="article-header draft-body">
                              {/* {<span className="article-card-publish">
                                Published by :{" "}
                                <span className="article-card-publish-font">
                                  {rawData.creator}
                                </span>
                              </span>} */}
                              <span className="article-card-date">
                                Modified on:
                                <span className="article-card-date-font">
                                  {" "}
                                  {moment(new Date(rawData.updated_at)).format(
                                    "MMMM D, YYYY"
                                  )}
                                </span>
                              </span>
                            </CardHeader>
                            <CardBody
                              className="draft-body"
                              style={{
                                maxHeight:
                                  this.state.articleSearchFilter != ""
                                    ? "max-content"
                                    : "10rem",
                              }}
                            >
                              <CardText>
                                <span className="article-text">
                                  <Editor
                                    editorState={EditorState.createWithContent(
                                      convertFromRaw(rawData.content)
                                    )}
                                    readOnly
                                    toolbarHidden
                                  />
                                </span>
                              </CardText>
                            </CardBody>
                            <br></br>
                          </div>
                        </Card>
                      ) : null}
                    </div>
                  ))
                : this.props.wikiList.map((wiki, index) =>
                    Array.isArray(wiki)
                      ? wiki.map((rawData) => (
                          <Card
                            className={
                              this.searchArticle(rawData)
                                ? "article-card"
                                : "article-card-search"
                            }
                          >
                            {index == 0 && rawData.draft ? (
                              <div>
                                <div
                                  className="delete-div"
                                  onClick={() =>
                                    this.toggleWikiDeleteClick(rawData.id)
                                  }
                                >
                                  <img
                                    src={deleteIcon}
                                    className="delete-icon"
                                    alt=""
                                  />
                                  <span> Delete</span>
                                </div>
                                <div
                                  className="edit-div"
                                  onClick={() => this.editData(rawData)}
                                >
                                  <img
                                    src={editIcon}
                                    alt=""
                                    className="edit-icon"
                                  />
                                  <span> Edit</span>
                                </div>
                                <CardHeader className="article-header draft-body">
                                  {/* {<span className="article-card-publish">
                                    Publisheddd by :{" "}
                                    <span className="article-card-publish-font">
                                      {rawData.creator}
                                    </span>
                                  </span>} */}
                                  <span className="article-card-date">
                                    Modified on :
                                    <span className="article-card-date-font">
                                      {" "}
                                      {moment(
                                        new Date(rawData.updated_at)
                                      ).format("MMMM D, YYYY")}
                                    </span>
                                  </span>
                                </CardHeader>
                                <CardBody
                                  className="draft-body"
                                  style={{
                                    maxHeight:
                                      this.state.articleSearchFilter != ""
                                        ? "max-content"
                                        : "10rem",
                                  }}
                                >
                                  <CardText>
                                    <span className="article-text">
                                      <Editor
                                        editorState={EditorState.createWithContent(
                                          convertFromRaw(rawData.content)
                                        )}
                                        readOnly
                                        toolbarHidden
                                      />
                                    </span>
                                  </CardText>
                                </CardBody>
                                <br></br>
                              </div>
                            ) : null}
                          </Card>
                        ))
                      : null
                  )}
            </div>
          ) : (
            <div>
              {role == "Lab.Tech"
                ? this.props.wikiList.map((rawData) => (
                    <div>
                      {!rawData.draft ? (
                        <Card
                          className={
                            this.searchArticle(rawData)
                              ? "article-card"
                              : "article-card-search"
                          }
                        >
                          <CardHeader className="article-header">
                            { <span className="article-card-publish">
                              Published by :{" "}
                              <span className="article-card-publish-font">
                                {rawData.creator}
                              </span>
                            </span> }
                            <span className="article-card-date">
                              Published on :
                              <span className="article-card-date-font">
                                {" "}
                                {moment(new Date(rawData.created_at)).format(
                                  "MMMM D, YYYY"
                                )}
                              </span>
                            </span>
                          </CardHeader>
                          <CardBody
                            className="article-card-body"
                            style={{
                              maxHeight:
                                this.state.articleSearchFilter != ""
                                  ? "max-content"
                                  : "10rem",
                            }}
                          >
                            <CardText>
                              <span className="article-text">
                                <Editor
                                  editorState={EditorState.createWithContent(
                                    convertFromRaw(rawData.content)
                                  )}
                                  readOnly
                                  toolbarHidden
                                />
                              </span>
                            </CardText>
                          </CardBody>
                          <hr></hr>
                        </Card>
                      ) : null}
                    </div>
                  ))
                : this.props.wikiList.map((wiki, index) =>
                    Array.isArray(wiki)
                      ? wiki.map((rawData) => (
                          <div>
                            {!rawData.draft ? (
                              <Card
                                className={
                                  this.searchArticle(rawData)
                                    ? "article-card"
                                    : "article-card-search"
                                }
                              >
                                <CardHeader className="article-header">
                                  { <span className="article-card-publish" >
                                    Published by :{" "}
                                    <span className="article-card-publish-font" >
                                      {rawData.creator}
                                    </span>
                                  </span> }
                                  <span className="article-card-date" >
                                    Published on :
                                    <span className="article-card-date-font" >
                                      {" "}
                                      {moment(
                                        new Date(rawData.created_at)
                                      ).format("MMMM D, YYYY")}
                                    </span>
                                  </span>
                                </CardHeader>
                                <CardBody
                                  className="article-card-body"
                                  style={{
                                    maxHeight:
                                      this.state.articleSearchFilter != ""
                                        ? "max-content"
                                        : "10rem",
                                  }}
                                >
                                  <CardText>
                                    <span className="article-text">
                                      <Editor
                                        editorState={EditorState.createWithContent(
                                          convertFromRaw(rawData.content)
                                        )}
                                        readOnly
                                        toolbarHidden
                                      />
                                    </span>
                                  </CardText>
                                </CardBody>
                                <hr></hr>
                              </Card>
                            ) : null}
                          </div>
                        ))
                      : null
                  )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    wikiList: state.wiki_data.wikiList,
  };
};
export default withAITracking(
  reactPlugin,
  connect(mapStateToProps, {
    saveWiki,
    getWiki,
    deleteWiki,
    updateWiki,
    saveAnnouncements,
  })(Wiki),
  "Wiki",
  "Wiki"
);
